import { SvgIcon } from "@mui/material";
import { IconProps } from "../_interface";

const ProductSecurity = (props: IconProps) => {
  return(
    <SvgIcon {...props} color="inherit" viewBox="0 0 40 40">
      <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="20" cy="20" r="20" fill="#F5E4E7"/>
      <g clipPath="url(#clip0_16014_102289)">
      <path d="M24.9987 13.3333H14.9987C14.0782 13.3333 13.332 14.0795 13.332 15V25C13.332 25.9205 14.0782 26.6666 14.9987 26.6666H24.9987C25.9192 26.6666 26.6654 25.9205 26.6654 25V15C26.6654 14.0795 25.9192 13.3333 24.9987 13.3333Z" stroke="#C72037" strokeWidth="2.08" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M22.5 17.5H17.5V22.5H22.5V17.5Z" stroke="#C72037" strokeWidth="2.08" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M17.5 10.8333V13.3333" stroke="#C72037" strokeWidth="2.08" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M22.5 10.8333V13.3333" stroke="#C72037" strokeWidth="2.08" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M17.5 26.6667V29.1667" stroke="#C72037" strokeWidth="2.08" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M22.5 26.6667V29.1667" stroke="#C72037" strokeWidth="2.08" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M26.668 17.5H29.168" stroke="#C72037" strokeWidth="2.08" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M26.668 21.6667H29.168" stroke="#C72037" strokeWidth="2.08" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M10.832 17.5H13.332" stroke="#C72037" strokeWidth="2.08" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M10.832 21.6667H13.332" stroke="#C72037" strokeWidth="2.08" strokeLinecap="round" strokeLinejoin="round"/>
      </g>
      <defs>
      <clipPath id="clip0_16014_102289">
      <rect width="20" height="20" fill="white" transform="translate(10 10)"/>
      </clipPath>
      </defs>
      </svg>
    </SvgIcon>
  );
}

export default ProductSecurity;

